export const invitationPending = 'invitationPending';
export const changed = 'changed';
